module.exports = __webpack_public_path__ + "static/img/Gold1.bc66e65.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coaching/widget/icons/game-ranks/apex/Gold1.svg
// module id = H42E
// module chunks = 38